// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"CheckboxInput_checkboxWrapper__3_dV6","checkboxCheck":"CheckboxInput_checkboxCheck__y1RcA"};